<template>
    <ul class="list check-list" :class="[sizeString ? 'list-' + sizeString : '']">
        <slot/>
    </ul>
</template>

<script>
import ListMixin from "../ListMixin";

    export default {
        name: "CheckList",

        mixins: [ListMixin]
    }
</script>